import { useLazyQuery } from "@apollo/client/react";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adaptConexionesABorrarArray, GET_CONEXIONES_A_BORRAR } from "../../../data/graphQL/queries/BorrarConexiones/getConexionesABorrar";

export const useGetRows = (filters, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getConexiones, { loading: conexionesLoading, data: conexiones }] = useLazyQuery(GET_CONEXIONES_A_BORRAR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (conexiones?.borrarConexiones) {
      const adaptedConexiones = adaptConexionesABorrarArray(conexiones.borrarConexiones);
      setRows(adaptedConexiones);
      setIsRefetchRequired(false);
    }
  }, [conexiones]);

  const handleSearch = useCallback(() => {
    if (!filters?.idPaciente || !filters?.idContrato || !filters?.fechaDesde || !filters?.fechaHasta) {
      toast.error("Debe ingresar todos los filtros para buscar las conexiones a borrar.");
      return;
    }

    if (moment(filters.fechaDesde).isAfter(moment(filters.fechaHasta))) {
      toast.error("La fecha desde no puede ser mayor a la fecha hasta.");
      return;
    }

    getConexiones({
      variables: {
        idPaciente: filters.idPaciente,
        idEvaluacion: filters.idContrato,
        fechaDesde: moment(filters.fechaDesde).format("YYYY-MM-DD 00:00"),
        fechaHasta: moment(filters.fechaHasta).format("YYYY-MM-DD 23:59"),
      }
    });
  }, [filters, getConexiones]);

  return {
    rows,
    setRows,
    loading: conexionesLoading,
    totalCount: rows?.length || 0,
    handleSearch
  };
};